
var Str = require('string');


module.exports.isStringNullOrEmpty = function(string)
{
    if (string == null)
        return true;

    return Str(string).isEmpty();
}

module.exports.trimString = function (string)
{
    if (string == null)
        return string;

    return Str(string).trim().s || null;
}

module.exports.areStringSame = function(string1, string2)
{
    string1 = this.trimString(string1);
    string2 = this.trimString(string2);

    if (string1 == null && string2 == null)
        return true;

    if (string1 == null || string2 == null)
        return false;

    return string1.toUpperCase() == string2.toUpperCase();
}

module.exports.replaceAll = function (string, searchString, replacedValue)
{
    return Str(string).replaceAll(searchString, replacedValue).s;
}

module.exports.toHumanize = function (string)
{
    return Str(string).humanize().s;
}

module.exports.sanitizeName = function (input)
{
    if(input == null)
        return null;

    return input.replace(/[^A-Za-z0-9@&,'\.\-\_\ \(\)\[\]]/g, "");
}
